<template>
  <v-layout wrap>
    <v-flex xs12>
      <AppForm label="ターゲティング種別" />
    </v-flex>
    <v-flex xs12 offset-xs1>
      <v-radio-group v-model="isSelectedRouteType" row>
        <v-radio
          :label="targetTypes.route.text"
          :value="true"
          @change="
            menuSetting.targetTypes = [
              routeTypes.commuting.value,
              routeTypes.passenger.value,
            ]
          "
        />
        <v-radio
          :label="targetTypes.station.text"
          :value="false"
          @change="menuSetting.targetTypes = [targetTypes.station.value]"
        />
      </v-radio-group>
    </v-flex>
    <v-flex
      v-if="isSelectedRouteType"
      xs2
      offset-xs1
      style="display:flex; flex-direction:row;"
    >
      <v-checkbox
        v-for="routeType in routeTypes"
        :key="routeType.vaue"
        :value="routeType.value"
        :label="routeType.text"
        v-model="menuSetting.targetTypes"
      />
    </v-flex>
    <v-flex xs10 offset-xs1 pl-4>
      <AppTwoColumnsSelectorWithFilteringAndSelectAll
        ref="selector"
        @setIds="selectedItemList = $event"
        @selectLargeCategory="selectLargeCategory"
        :items="selectableItemList"
        :itemName="itemName"
        :addedIdAndNameList="selectedItemList"
        :isShowRightAllSelect="true"
        :canMoveRight="canMoveRight"
        :useSearch="true"
        :leftFooter="leftFooter"
        :rightFooter="rightFooter"
        :errorMessage="errorMessageForSelector"
        :canNextCategory="canNextCategory"
      >
        <template slot="leftLabel">
          <v-breadcrumbs :items="breadcrumbs" divider=">">
            <template v-slot:item="{ item }">
              <v-breadcrumbs-item
                :disabled="item.disabled"
                @click="selectableCategoryType = item.name"
              >
                {{ item.text }}
                <span v-if="item.value.name"> : {{ item.value.name }}</span>
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
        </template>
      </AppTwoColumnsSelectorWithFilteringAndSelectAll>
    </v-flex>
    <v-flex xs12 pt-3>
      <AppForm label="備考" />
    </v-flex>
    <v-flex xs10 mt-1 offset-xs1>
      <span v-if="menuSetting.targetTypes.includes(routeTypes.passenger)">
        ※ 路線の駅間指定をされる場合、こちらにご記入ください。
        （お申し込み金額50万円以上からご指定可能です）
        <p style="margin-left: 20px;">
          50 万円以上 10区間まで<br />
          100万円以上 30区間まで
        </p>
      </span>
      <v-textarea v-model="menuSetting.memo" outline />
    </v-flex>
  </v-layout>
</template>

<script>
import { MasterRepository } from '@/models/Master/MasterRepository'
import {
  RailwayCategoryTypes,
  RailwayTargetTypes,
} from '@/models/Menu/Constants'

export default {
  name: 'CampaignModalPageRailway',
  components: {},
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      selectableItemList: [],
      selectedLineItemList: [],
      selectedStationItemList: [],
      selectableCategoryType: RailwayCategoryTypes.Company,
      breadcrumb: {
        selectedCompany: {},
        selectedLine: {},
      },
      MAX_COUNT_SELECTED_LINES: 99,
      isSelectedRouteType: true,
    }
  },
  computed: {
    menuSetting() {
      return this.form.campaign.menuSetting.orderDescription
    },
    targetObj() {
      if (this.menuSetting.targetTypes.includes(RailwayTargetTypes.Station)) {
        return this.menuSetting.target.railwayStationTargetObj
      } else {
        return this.menuSetting.target.railwayLineTargetObj
      }
    },
    itemName() {
      switch (this.selectableCategoryType) {
        case RailwayCategoryTypes.Company:
          return '鉄道事業者'
        case RailwayCategoryTypes.Line:
          return '路線'
        case RailwayCategoryTypes.Station:
          return '駅'
        default:
          return ''
      }
    },
    targetTypes() {
      return {
        route: {
          text: '路線',
          value: RailwayTargetTypes.Route,
        },
        station: {
          text: '駅',
          value: RailwayTargetTypes.Station,
        },
      }
    },
    routeTypes() {
      return {
        commuting: {
          text: '生活路線',
          value: RailwayTargetTypes.Commuting,
        },
        passenger: {
          text: '乗客',
          value: RailwayTargetTypes.Passenger,
        },
      }
    },
    selectedItemList: {
      get() {
        if (this.menuSetting.targetTypes.includes(RailwayTargetTypes.Station)) {
          return this.selectedStationItemList
        } else {
          return this.selectedLineItemList
        }
      },
      set(value) {
        if (this.menuSetting.targetTypes.includes(RailwayTargetTypes.Station)) {
          this.selectedStationItemList = value
        } else {
          this.selectedLineItemList = value
        }
      },
    },
    breadcrumbs() {
      const companyBreadcrumb = {
        name: RailwayCategoryTypes.Company,
        text: '鉄道事業者',
        value: this.breadcrumb.selectedCompany,
        disabled: this.breadcrumb.selectedCompany.name === undefined,
      }
      const lineBreadcrumb = {
        name: RailwayCategoryTypes.Line,
        text: '路線',
        value: this.breadcrumb.selectedLine,
        disabled: this.breadcrumb.selectedLine.name === undefined,
      }
      const stationBreadcrumb = {
        name: RailwayCategoryTypes.Station,
        text: '駅',
        value: {},
        disabled: true,
      }
      switch (this.selectableCategoryType) {
        case RailwayCategoryTypes.Company:
          return [companyBreadcrumb]
        case RailwayCategoryTypes.Line:
          return [companyBreadcrumb, lineBreadcrumb]
        case RailwayCategoryTypes.Station:
          return [companyBreadcrumb, lineBreadcrumb, stationBreadcrumb]
        default:
          return []
      }
    },
    canNextCategory() {
      if (this.menuSetting.targetTypes.includes(RailwayTargetTypes.Station)) {
        return this.selectableCategoryType !== RailwayCategoryTypes.Station
      } else {
        return this.selectableCategoryType === RailwayCategoryTypes.Company
      }
    },
    leftFooter() {
      if (this.selectableCategoryType === RailwayCategoryTypes.Company) {
        return '事業者を選択して下さい。'
      }
      if (
        this.selectableCategoryType === RailwayCategoryTypes.Line &&
        this.menuSetting.targetTypes.includes(RailwayTargetTypes.Station)
      ) {
        return '路線を選択して下さい。'
      }
      return ''
    },
    rightFooter() {
      if (this.menuSetting.targetTypes.includes(RailwayTargetTypes.Station)) {
        return 'ご指定可能な駅の路線数は最大99路線までです。'
      } else {
        return 'ご指定可能な路線数は99路線までです。'
      }
    },
    isOverRailwayLines() {
      return this.targetObj.countRailwayLines >= this.MAX_COUNT_SELECTED_LINES
    },
    canMoveRight() {
      if (this.menuSetting.targetTypes.includes(RailwayTargetTypes.Station)) {
        if (!this.isOverRailwayLines) return true
        if (!this.breadcrumb.selectedLine.id) return false

        return this.selectedStationItemList.some(
          station => station.lineId === this.breadcrumb.selectedLine.id,
        )
      } else {
        return !this.isOverRailwayLines
      }
    },
    errorMessageForSelector() {
      if (this.isOverRailwayLines) {
        return (
          '※ 現在、配信対象に' +
          this.targetObj.countRailwayLines +
          '路線指定されています。'
        )
      } else {
        return ''
      }
    },
    errorMessage() {
      const errorMessages = []
      if (this.isOverRailwayLines) {
        errorMessages.push(
          '1キャンペーンあたり設定可能な路線数は、99路線です。\n99路線以上ご指定される場合、別途キャンペーンを作成して下さい。',
        )
      }
      if (this.targetObj.countTarget === 0) {
        if (this.menuSetting.targetTypes.includes(RailwayTargetTypes.Station)) {
          errorMessages.push('駅を1件以上指定して下さい。')
        } else {
          errorMessages.push('鉄道路線を1件以上指定して下さい。')
        }
      }
      if (this.menuSetting.targetTypes.length === 0) {
        errorMessages.push('「生活路線」「乗客」のいずれかを選択して下さい。')
      }
      return errorMessages.length === 0 ? '' : errorMessages
    },
  },
  watch: {
    async selectableCategoryType() {
      this.$refs.selector.clearKeyword()
      this.clearSelectedItem()
      await this.makeSelectableItemList()
    },
    'menuSetting.targetTypes'(newValue, oldValue) {
      if (oldValue.includes(RailwayTargetTypes.Station)) {
        this.breadcrumb.selectedLine = {}
        if (this.selectableCategoryType === RailwayCategoryTypes.Station) {
          this.selectableCategoryType = RailwayCategoryTypes.Line
        }
      }
    },
    selectedItemList() {
      this.targetObj.makeRailwayCompanies(this.selectedItemList)
    },
  },
  async created() {
    await this.makeSelectableItemList()
    this.init()
  },
  methods: {
    init() {
      if (this.menuSetting.targetTypes.includes(RailwayTargetTypes.Station)) {
        this.targetObj.railwayCompanies.forEach(company => {
          company.railwayLines.forEach(line => {
            const selectedItemList = line.stationIdAndNames.map(station => {
              return {
                id: station.stationId,
                name: station.stationName,
                lineId: line.id,
                lineName: line.name,
                companyId: company.id,
                companyName: company.name,
              }
            })
            this.selectedStationItemList = this.selectedStationItemList.concat(
              selectedItemList,
            )
          })
        })
      } else {
        this.targetObj.railwayCompanies.forEach(company => {
          const selectedItemList = company.railwayLineIdAndNames.map(line => {
            return {
              id: line.railwayLineId,
              name: line.railwayLineName,
              companyId: company.railwayCompanyId,
              companyName: company.railwayCompanyName,
            }
          })
          this.selectedLineItemList = this.selectedLineItemList.concat(
            selectedItemList,
          )
        })
      }
    },
    clearSelectedItem() {
      if (this.selectableCategoryType === RailwayCategoryTypes.Company) {
        this.breadcrumb.selectedCompany = {}
        this.breadcrumb.selectedLine = {}
      }
      if (this.selectableCategoryType === RailwayCategoryTypes.Line) {
        this.breadcrumb.selectedLine = {}
      }
    },
    async makeSelectableItemList() {
      switch (this.selectableCategoryType) {
        case RailwayCategoryTypes.Company:
          this.selectableItemList = await MasterRepository.fetchRailwayCompanyList(
            {
              pageSize: 300,
            },
          )
          break
        case RailwayCategoryTypes.Line:
          this.selectableItemList = await MasterRepository.fetchRailwayLineList(
            { companyId: this.breadcrumb.selectedCompany.id },
          )
          break
        case RailwayCategoryTypes.Station:
          this.selectableItemList = await MasterRepository.fetchRailwayStationList(
            {
              companyId: this.breadcrumb.selectedCompany.id,
              lineId: this.breadcrumb.selectedLine.id,
            },
          )
          break
      }
    },
    selectLargeCategory(item) {
      if (this.selectableCategoryType === RailwayCategoryTypes.Company) {
        this.selectableCategoryType = RailwayCategoryTypes.Line
        this.breadcrumb.selectedCompany = item
      } else if (this.selectableCategoryType === RailwayCategoryTypes.Line) {
        this.selectableCategoryType = RailwayCategoryTypes.Station
        this.breadcrumb.selectedLine = item
      }
    },
  },
}
</script>

<style scoped>
.v-textarea >>> textarea {
  margin-top: 0;
}
</style>
